module.exports = __webpack_public_path__ + "img/cart-empty.2a50016.webp";